export enum FEATURE_FLAGS {
  facebookAuth = 'sso_facebook_login',
  ssoRevamp = 'sso_revamp',
}
